import { useUser } from "../use-user";

export const useHasPasskeyEnabled = () => {
  const user = useUser();

  if (!user) return false;

  return user.is_passkey_enabled;
};

export const useIsPasskeyOnlyUser = () => {
  const user = useUser();

  if (!user) return false;

  return user.is_passkey_enabled && !user.is_otp_enabled;
};
